import { render } from "./SkillsAuditAssessmentViewer.vue?vue&type=template&id=b2a119fc&scoped=true"
import script from "./SkillsAuditAssessmentViewer.vue?vue&type=script&lang=js"
export * from "./SkillsAuditAssessmentViewer.vue?vue&type=script&lang=js"

import "./SkillsAuditAssessmentViewer.vue?vue&type=style&index=0&id=b2a119fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a119fc"]])

export default __exports__